module.exports = __webpack_public_path__ + "static/media/mail.89896ce1.svg";